const LIST = '/sales/receipt/list'
const CREATE = '/sales/receipt/create'
const ONE_RECEIPT = '/sales/receipt/onereceipt/'
const DELETE_RECEIPT_ITEM = '/sales/receipt/receiptItem/'
const ADD_RECEIPT_ITEM = '/sales/receipt/addReceiptItem'
const EDIT_RECEIPT_ITEM = '/sales/receipt/editreceiptitem'
const DELETE_RECEIPT = '/sales/receipt/receipt/'
const EXPORT_RECEIPT = '/sales/receipt/export'
const EDIT_RECEIPT = '/sales/receipt/'
const BEFORE = '/sales/receipt/before'
const GENERATE_RECEIPT = '/sales/receipt/generate/'

export const salesReceiptEndpoints = {
  LIST,
  CREATE,
  ONE_RECEIPT,
  DELETE_RECEIPT_ITEM,
  ADD_RECEIPT_ITEM,
  EDIT_RECEIPT_ITEM,
  DELETE_RECEIPT,
  EXPORT_RECEIPT,
  EDIT_RECEIPT,
  BEFORE,
  GENERATE_RECEIPT,
}
